import React, { useCallback } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import { Button, Popconfirm } from "@mapmycustomers/ui";

import { unarchiveField } from "@app/scene/settings/component/ManageFields/store/actions";

interface Props {
  field: SchemaField;
  onAction?: (field: SchemaField) => void;
  unarchiveField: typeof unarchiveField.request;
}

const UnarchiveAction: React.FC<Props> = ({ field, onAction, unarchiveField }) => {
  const intl = useIntl();

  const handleClick = useCallback(() => {
    unarchiveField(field);
    onAction?.(field);
  }, [field, onAction, unarchiveField]);

  return (
    <span>
      <Popconfirm
        cancelText={intl.formatMessage({
          id: "settings.manageFields.grid.actions.unarchive.cancel",
          defaultMessage: "Wait",
          description: "Cancel button title for unarchive action confirmation",
        })}
        description={intl.formatMessage({
          id: "settings.manageFields.grid.actions.unarchive.confirm.description",
          defaultMessage: "This field may become immediately visible to users",
          description: "Unarchive action confirmation text",
        })}
        disabled={!field.archived}
        okText={intl.formatMessage({
          id: "settings.manageFields.grid.actions.unarchive.ok",
          defaultMessage: "I’m sure",
          description: "OK button title for unarchive action confirmation",
        })}
        onConfirm={handleClick}
        placement="bottomLeft"
        title={intl.formatMessage({
          id: "settings.manageFields.grid.actions.unarchive.confirm.title",
          defaultMessage: "Are you sure you want to unarchive this field?",
          description: "Unarchive action confirmation text",
        })}
      >
        <Button disabled={!field.archived}>
          {intl.formatMessage({
            id: "settings.manageFields.grid.actions.unarchive",
            defaultMessage: "Unarchive",
            description: "Title of the Unarchive button in the Field Name column",
          })}
        </Button>
      </Popconfirm>
    </span>
  );
};

const mapDispatchToProps = {
  unarchiveField: unarchiveField.request,
};

export default connect(null, mapDispatchToProps)(UnarchiveAction);
